var _style, _path, _path2, _rect, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSpain = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 42",
    style: {
      enableBackground: "new 0 0 64 42"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.es_st0{fill:#BC091C;}\n\t.es_st1{fill:#FFC400;}\n\t.es_st2{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_7_copy_1_",
    className: "es_st0",
    d: "M5.8,0h52.3C61.4,0,64,2.6,64,5.7v30.6c0,3.2-2.6,5.7-5.8,5.7H5.8 C2.6,42,0,39.4,0,36.3V5.7C0,2.6,2.6,0,5.8,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "es_st0",
    d: "M0,36.3C0,39.4,2.6,42,5.8,42h52.4c3.2,0,5.8-2.5,5.8-5.7V14H0V36.3z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 9.2,
    className: "es_st1",
    width: 64,
    height: 23.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "es_st2",
    d: "M53.8,21.5c-2.1,0-3.2-1.5-3.2-1.5s-1.1,1.5-3.3,1.5c-1.9,0-3.3-1.2-3.3-1.2v8.2c0.1,5.4,6.5,7.6,6.5,7.6 s6.5-2.2,6.5-7.6v-8.2C57,20.3,55.7,21.5,53.8,21.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "es_st0",
    d: "M11.4,18.1C11.4,18.1,11.4,18.1,11.4,18.1C11.4,18.2,11.5,18.2,11.4,18.1c0.1,0.1,0.1,0.1,0.2,0.1 c0,0,0.1,0,0.1,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0.1l0,0l0,0l0.1,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.3,0h-0.7v0.6h0.3c-0.1,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0l0,0 c0.1,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1h1.6c0.1,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1 c0,0,0,0,0,0c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1h0.3v-0.6h-0.7 c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0.1,0h0l0,0c0,0,0-0.1,0-0.1c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0.1-0.1c0,0,0.1,0,0.1,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1 c0,0-0.1,0-0.1,0l0,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0 c0,0-0.1,0-0.1,0c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0h0v-0.1h0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v-0.1h0.1v-0.1h-0.1v-0.1h-0.1v0.1h-0.1v0.1h0.1v0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0h0v0.1h0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0-0.1,0-0.2,0 c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0s0,0,0,0c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0.1c0,0,0,0,0,0l0,0c0,0,0,0,0,0 s-0.1,0-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0.1,0,0.2,0,0.2c0,0,0,0,0,0c0,0-0.1,0-0.1,0C11.3,18,11.3,18,11.4,18.1 C11.4,18.1,11.4,18.1,11.4,18.1z M11.6,19.6C11.6,19.6,11.6,19.6,11.6,19.6C11.6,19.6,11.6,19.6,11.6,19.6z M12.9,18.2 C12.9,18.2,12.9,18.2,12.9,18.2C12.9,18.2,12.9,18.2,12.9,18.2L12.9,18.2z M12.9,18.5c-0.1,0-0.3,0-0.4-0.1 C12.7,18.4,12.8,18.4,12.9,18.5z M12.4,18.4C12.4,18.4,12.4,18.4,12.4,18.4C12.4,18.4,12.4,18.4,12.4,18.4c-0.2,0-0.5,0-0.6,0.1 C11.9,18.4,12.1,18.4,12.4,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "es_st0",
    d: "M13.5,28.5C13.5,28.4,13.5,28.4,13.5,28.5l0-0.5h0c-0.1,0-0.3-0.1-0.3-0.2c0,0,0,0,0-0.1c0,0,0,0,0,0 c0.1,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1h-1.6c-0.1,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0.1 c0,0.1-0.1,0.2-0.3,0.2h0v0.5c0,0,0,0,0,0c-0.1,0.1-0.2,0.1-0.4,0.1v0.2c0.1,0,0.3,0,0.4-0.1c0,0,0,0,0.1,0c0,0-0.1,0-0.1,0 c-0.1,0.1-0.2,0.1-0.4,0.1V29v0.2c0.1,0,0.3,0,0.4-0.1c-0.1,0.1-0.2,0.1-0.4,0.1v0.2c0.1,0,0.3,0,0.4-0.1c0.1,0,0.2-0.1,0.4-0.1 c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.3,0,0.4-0.1c0.1,0,0.2-0.1,0.4-0.1c0.1,0,0.3,0,0.4,0.1c0,0,0,0,0,0 c0,0,0,0,0,0c-0.1,0-0.2-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.2,0.1-0.4,0.1c-0.1,0-0.3,0-0.4-0.1c-0.1,0-0.2-0.1-0.4-0.1 c-0.1,0-0.3,0-0.4,0.1c-0.1,0.1-0.2,0.1-0.4,0.1v0.2c0.1,0,0.3,0,0.4-0.1c0.1,0,0.2-0.1,0.4-0.1c0.1,0,0.3,0,0.4,0.1 c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.3,0,0.4-0.1c0.1,0,0.2-0.1,0.4-0.1c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.1,0.4,0.1v0l0-0.2 c0,0,0,0,0,0l0-0.2c0,0,0,0,0,0l0-0.2v0c0,0,0,0,0,0l0-0.2c0,0,0,0,0,0l0-0.2C13.7,28.5,13.6,28.5,13.5,28.5z M12.8,28.5 c-0.1,0-0.2,0.1-0.4,0.1c-0.1,0-0.3,0-0.4-0.1H12.8z M11.7,28.6c0,0-0.1,0-0.1,0C11.6,28.6,11.6,28.6,11.7,28.6 C11.7,28.6,11.7,28.6,11.7,28.6C11.7,28.6,11.7,28.6,11.7,28.6z M13.5,28.7c-0.1,0-0.2-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0.1 c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.3,0-0.4-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.3,0,0.4-0.1 c0.1,0,0.2-0.1,0.4-0.1C13.3,28.6,13.4,28.6,13.5,28.7C13.5,28.7,13.5,28.7,13.5,28.7C13.5,28.7,13.5,28.7,13.5,28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "es_st0",
    d: "M25.5,17.9C25.5,18,25.5,18,25.5,17.9L25.5,17.9C25.5,18,25.5,18,25.5,17.9C25.5,18,25.4,18,25.5,17.9 c-0.1,0.1,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0c0,0,0,0,0,0l0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0.1l0,0l0,0h0l0.1,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0.1,0.1,0.1 c0.1,0,0.1,0,0.3,0h-0.7v0.6h0.3c-0.1,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0l0,0c0.1,0,0.1,0.1,0.1,0.1 c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1h1.6c0.1,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0 c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1h0.3v-0.6h-0.7c0.1,0,0.2,0,0.3,0 c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0.1,0l0,0c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0.1-0.1c0,0,0.1,0,0.1,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0-0.1-0.1-0.3-0.3-0.3 c0,0-0.1,0-0.1,0l0.1,0.1c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0-0.1-0.1-0.2-0.2-0.2 c-0.1,0-0.1,0-0.2,0l0.2,0.1c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0c0,0,0,0,0-0.1c0-0.1,0-0.1-0.1-0.2c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0h0v-0.1h0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v-0.1h0.1v-0.1h-0.1v-0.1h-0.1v0.1h-0.1v0.1 h0.1v0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0h0v0.1h0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0-0.1,0.1-0.1,0.2c0,0,0,0,0,0.1c0,0-0.1,0-0.2,0c0,0,0,0,0,0l0.2-0.1c0,0-0.1,0-0.2,0c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0l0.1-0.1c0,0-0.1,0-0.1,0C25.7,17.7,25.5,17.8,25.5,17.9z M25.7,19.6 C25.7,19.6,25.7,19.6,25.7,19.6C25.7,19.6,25.7,19.6,25.7,19.6z M27.1,18.5c-0.1,0-0.3,0-0.4-0.1C26.8,18.4,27,18.4,27.1,18.5z  M26.5,18.2c0,0,0.1,0,0.1,0C26.6,18.2,26.6,18.2,26.5,18.2C26.5,18.2,26.5,18.2,26.5,18.2z M26.5,18.4 C26.6,18.4,26.6,18.4,26.5,18.4C26.6,18.4,26.6,18.4,26.5,18.4c-0.2,0-0.5,0-0.6,0.1C26.1,18.4,26.3,18.4,26.5,18.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "es_st0",
    cx: 25.5,
    cy: 17.9,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    className: "es_st0",
    cx: 25.5,
    cy: 17.8,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    className: "es_st0",
    cx: 25.6,
    cy: 17.6,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    className: "es_st0",
    cx: 25.7,
    cy: 17.6,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    className: "es_st0",
    cx: 25.9,
    cy: 17.6,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    className: "es_st0",
    cx: 26,
    cy: 17.6,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    className: "es_st0",
    cx: 26.1,
    cy: 17.5,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    className: "es_st0",
    cx: 26.2,
    cy: 17.5,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    className: "es_st0",
    cx: 26.3,
    cy: 17.5,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    className: "es_st0",
    cx: 26.7,
    cy: 17.5,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    className: "es_st0",
    cx: 26.9,
    cy: 17.5,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    className: "es_st0",
    cx: 27,
    cy: 17.5,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    className: "es_st0",
    cx: 27.1,
    cy: 17.6,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    className: "es_st0",
    cx: 27.2,
    cy: 17.6,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    className: "es_st0",
    cx: 27.4,
    cy: 17.6,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    className: "es_st0",
    cx: 27.5,
    cy: 17.6,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    className: "es_st0",
    cx: 27.6,
    cy: 17.8,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    className: "es_st0",
    cx: 27.6,
    cy: 17.9,
    r: 0
  }), /*#__PURE__*/React.createElement("path", {
    className: "es_st0",
    d: "M27.7,28.5C27.6,28.4,27.6,28.4,27.7,28.5l0-0.5h0c-0.1,0-0.3-0.1-0.3-0.2c0,0,0,0,0-0.1c0,0,0,0,0,0 c0.1,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1h-1.6c-0.1,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0.1 c0,0.1-0.1,0.2-0.3,0.2h0v0.5c0,0,0,0,0,0c-0.1,0.1-0.2,0.1-0.4,0.1v0.2c0.1,0,0.3,0,0.4-0.1c0,0,0,0,0.1,0c0,0-0.1,0-0.1,0 c-0.1,0.1-0.2,0.1-0.4,0.1V29v0.2c0.1,0,0.3,0,0.4-0.1c-0.1,0.1-0.2,0.1-0.4,0.1v0.2c0.1,0,0.3,0,0.4-0.1c0.1,0,0.2-0.1,0.4-0.1 c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.3,0,0.4-0.1c0.1,0,0.2-0.1,0.4-0.1c0.1,0,0.3,0,0.4,0.1c0,0,0,0,0,0 c0,0,0,0,0,0c-0.1,0-0.2-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.2,0.1-0.4,0.1c-0.1,0-0.3,0-0.4-0.1c-0.1,0-0.2-0.1-0.4-0.1 c-0.1,0-0.3,0-0.4,0.1c-0.1,0.1-0.2,0.1-0.4,0.1v0.2c0.1,0,0.3,0,0.4-0.1c0.1,0,0.2-0.1,0.4-0.1c0.1,0,0.3,0,0.4,0.1 c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.3,0,0.4-0.1c0.1,0,0.2-0.1,0.4-0.1c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.1,0.4,0.1v0l0-0.2 c0,0,0,0,0,0l0-0.2c0,0,0,0,0,0l0-0.2v0c0,0,0,0,0,0l0-0.2c0,0,0,0,0,0l0-0.2C27.9,28.5,27.8,28.5,27.7,28.5z M26.9,28.5 c-0.1,0-0.2,0.1-0.4,0.1c-0.1,0-0.3,0-0.4-0.1H26.9z M25.7,28.6c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0 C25.8,28.6,25.7,28.6,25.7,28.6z M25.8,29.1L25.8,29.1c0,0,0.1,0,0.1,0C25.9,29.1,25.8,29.1,25.8,29.1z M27.7,28.7 c-0.1,0-0.2-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0.1c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.3,0-0.4-0.1c0,0,0,0,0,0c0,0,0,0,0,0 c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.3,0,0.4-0.1c0.1,0,0.2-0.1,0.4-0.1C27.4,28.6,27.6,28.6,27.7,28.7C27.7,28.7,27.7,28.7,27.7,28.7 C27.7,28.7,27.7,28.7,27.7,28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "es_st0",
    d: "M28.1,23.3c0,0,0.3-0.8,0.4-0.8c0-0.3-0.4-0.6-1.1-0.8v-1.9h-1.5v1.7c-0.6,0-1.2,0.1-1.5,0.2v-3.1h-3.5 c0.6-0.1,1.2-0.2,1.7-0.3c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0c-0.1,0-0.1-0.1,0-0.2l0,0l0.2-0.1h0l-0.1-0.1 c0.1-0.1,0.1-0.1,0.2-0.1c0,0,0,0,0,0c0.1,0,0.1,0,0.1-0.1c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.2,0l0,0c0,0,0.1,0,0.1,0 c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.3-0.3,0.3-0.3c0.1,0,0.1,0,0.2,0c0.1-0.1,0.1-0.2,0-0.2c0,0,0,0,0,0c0,0,0.1-0.2,0.2-0.3 c0.1-0.1,0.3,0,0.3,0c0-0.2-0.1-0.3-0.3-0.3c0,0,0,0,0,0l0-0.1l0,0l0.1-0.1l0,0c0.1-0.2,0.2-0.4,0.2-0.6c0-0.4-0.3-0.7-0.6-1 c0,0,0.1,0.1,0.1,0.1c-0.3-0.2-0.8-0.4-1.3-0.4c-0.1,0-0.3,0-0.4,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0,0,0 c0,0,0,0,0,0c-0.1-0.1-0.2-0.2-0.3-0.3c0.1,0.1,0.2,0.2,0.2,0.2c-0.2-0.3-0.7-0.6-1.2-0.6c-0.3,0-0.6,0.1-0.9,0.2c0,0,0,0,0,0 c0,0,0-0.1-0.1-0.1c0,0,0,0,0.1,0c0.1,0,0.1,0,0.1-0.1c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1c0,0,0,0,0,0c0,0-0.1-0.1-0.2-0.1 c0.1,0,0.2-0.1,0.3-0.2h0c0,0,0,0,0,0c0,0,0-0.1,0-0.2c0,0,0,0,0,0c0-0.2-0.1-0.3-0.3-0.4v0v-0.3h0.2v-0.2h-0.2v-0.2h-0.2v0.2h-0.2 v0.2h0.2v0.3v0c-0.2,0-0.3,0.2-0.3,0.4c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0.1,0.2,0.2,0.3,0.2 c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0,0,0c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1c0,0.1,0,0.1,0.1,0.1c0,0,0,0,0.1,0 c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0c-0.2-0.1-0.5-0.2-0.9-0.2c-0.5,0-1,0.2-1.2,0.6c0.1-0.1,0.1-0.2,0.2-0.2c-0.1,0.1-0.2,0.2-0.3,0.3 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c-0.1,0-0.3,0-0.4,0c-0.5,0-0.9,0.1-1.2,0.3c0,0,0,0,0,0 c-0.4,0.2-0.6,0.6-0.6,1c0,0.2,0.1,0.4,0.2,0.6l0,0l0.1,0.1l0,0c-0.1,0-0.2,0.1-0.2,0.3c0,0,0.2,0,0.3,0c0.1,0.1,0.2,0.3,0.2,0.3 c0,0,0,0,0,0c0,0.1,0,0.1,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0c0.1,0.1,0.2,0.3,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.1c0,0,0,0,0.1,0l0,0 c0,0-0.1,0-0.1,0c-0.1,0-0.1,0.1-0.1,0.1c0,0.1,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0.1,0,0.2,0.1l-0.1,0.1l0.2,0.1l0,0 c0,0.1,0,0.2,0,0.2c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0.1,0.1c0.5,0.1,1,0.2,1.7,0.3h-3.5v3.1c-0.3-0.1-0.9-0.2-1.5-0.2 c0,0,0,0,0,0v-1.7h-1.5v1.9c-0.7,0.2-1.2,0.5-1.1,0.8c0,0,0.4,0.8,0.4,0.8c0,0,0,0,0,0v0c0,0.2,0.3,0.3,0.8,0.3l0-0.7 c-0.1,0-0.3,0-0.4,0c0.1-0.1,0.2-0.1,0.4-0.2v0.2v1.6c-0.6,0.2-1,0.5-1,0.6v0l0.1,0.8v0c0,0.1,0.1,0.1,0.2,0.2 c0.2,0.1,0.2,0.3,0.2,0.4c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4c0.1-0.1,0.3-0.2,0.5-0.2v2.1h1.5v-2.8 c0.5-0.3,0.7-0.5,0.7-0.6c0,0-0.1-0.7-0.1-0.8l0,0l0,0c-0.1-0.1-0.3-0.1-0.6-0.2v0l0,0.7v-1.4c0,0,0,0,0,0c0.6,0,1.2,0.1,1.5,0.3 v1.1h0l0,3.2h0c0,0.1,0,0.2,0,0.3c0,0.2,0.1,0.5,0.2,0.7c0.1,0.1,0.1,0.2,0.2,0.4c0,0.1,0.1,0.1,0.1,0.2v0c0.2,0.2,0.5,0.4,0.7,0.6 c1,0.5,2.3,0.8,3.5,0.8h0c1.2,0,2.5-0.3,3.5-0.8c0.5-0.3,0.9-0.7,1.1-1.3c0.1-0.2,0.1-0.5,0.1-0.7v-3.2h0h0v-1.2 c0.3-0.1,0.9-0.2,1.5-0.2c0,0,0,0,0,0V23c-0.3,0-0.5,0.1-0.6,0.2l0,0l0,0c0,0-0.1,0.8-0.1,0.8c-0.1,0.1,0.2,0.3,0.7,0.6v2.8h1.5 v-2.1c0,0,0,0,0,0c0.2,0.1,0.3,0.1,0.5,0.2c-0.1,0.1-0.2,0.3-0.2,0.4c0,0.2,0.1,0.3,0.2,0.4c-0.1-0.1,0-0.3,0.2-0.4 c0.1-0.1,0.2-0.1,0.2-0.2v0l0.1-0.8v0c0-0.1-0.4-0.4-1-0.6v-1.8c0.1,0.1,0.3,0.1,0.4,0.2c-0.1,0-0.2,0-0.4,0l0,0.7 C27.8,23.5,28,23.4,28.1,23.3C28.1,23.3,28.1,23.3,28.1,23.3C28.1,23.3,28.1,23.3,28.1,23.3C28.1,23.3,28.1,23.3,28.1,23.3z  M24,15.6L24,15.6c0,0,0-0.1,0.1-0.1C24.1,15.5,24.1,15.5,24,15.6z M24.1,14.7C24.1,14.7,24.1,14.8,24.1,14.7 C24.1,14.8,24.1,14.7,24.1,14.7C24.1,14.7,24.1,14.6,24.1,14.7C24.1,14.6,24.1,14.7,24.1,14.7z M24,14.5C24,14.5,23.9,14.5,24,14.5 C23.9,14.5,24,14.5,24,14.5z M23.9,14.4C23.9,14.4,23.9,14.4,23.9,14.4C23.9,14.4,23.9,14.4,23.9,14.4z M22.1,14.2 C22.1,14.2,22.1,14.2,22.1,14.2C22.1,14.2,22.1,14.2,22.1,14.2c0.2,0,0.3,0,0.5,0c0.7,0,1.3,0.3,1.4,0.6c0,0.1,0.1,0.2,0.1,0.3 c0,0.1,0,0.3-0.1,0.4c-0.1-0.1-0.3-0.2-0.5-0.3C23,15,22.7,15,22.4,15c-0.1,0-0.2,0-0.2,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1 c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0.1,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1-0.1c0-0.1,0-0.1-0.1-0.1 c0,0,0,0,0,0C22.1,14.3,22.1,14.2,22.1,14.2C22.1,14.2,22.1,14.2,22.1,14.2z M15.1,14.3c0,0-0.1,0.1-0.1,0.1 C15,14.4,15.1,14.3,15.1,14.3z M16.8,14.3C16.8,14.3,16.8,14.3,16.8,14.3c-0.1,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1c0,0,0,0.1,0,0.1 c0,0-0.1,0-0.1,0.1c0,0.1,0,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0c-0.1,0-0.2,0-0.3,0 c-0.3,0-0.6,0.1-1,0.2c-0.2,0.1-0.3,0.2-0.5,0.3c-0.1-0.1-0.1-0.2-0.1-0.4c0-0.1,0-0.2,0.1-0.3c0.2-0.4,0.7-0.6,1.4-0.6 c0.1,0,0.3,0,0.4,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0C16.8,14.2,16.8,14.3,16.8,14.3z M13.6,23.4c0,0-0.1,0.1-0.1,0.1 C13.6,23.5,13.6,23.4,13.6,23.4z M20.7,13.6c0.6,0,1.1,0.3,1.2,0.8c0,0,0,0.1,0,0.1c0,0.2-0.1,0.3-0.2,0.4c-0.3,0-0.5-0.1-0.7-0.2 c-0.3-0.1-0.7-0.2-1.1-0.2c0-0.1,0-0.2,0-0.3c0,0,0,0,0-0.1c0,0,0,0,0,0c0-0.1,0-0.2,0-0.2C20,13.7,20.3,13.6,20.7,13.6z  M17.9,14.7c-0.2,0.1-0.4,0.1-0.7,0.2c-0.1-0.1-0.2-0.3-0.2-0.4c0,0,0-0.1,0-0.1c0-0.4,0.5-0.8,1.2-0.8c0.3,0,0.6,0.1,0.8,0.2 c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0.1,0,0.2,0,0.3C18.6,14.5,18.2,14.6,17.9,14.7z M19.5,17.7c-0.3,0-0.5,0-0.8,0 C18.9,17.7,19.2,17.7,19.5,17.7c0.2,0,0.3,0,0.5,0C19.8,17.7,19.6,17.7,19.5,17.7z M25.3,23.4c0,0,0.1,0.1,0.1,0.1 C25.4,23.5,25.3,23.4,25.3,23.4z M25.8,23.7C25.8,23.7,25.7,23.7,25.8,23.7C25.7,23.7,25.8,23.7,25.8,23.7L25.8,23.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 14.6,
    cy: 16,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 14.5,
    cy: 15.8,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 14.4,
    cy: 15.5,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 14.4,
    cy: 15.2,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 14.4,
    cy: 14.8,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 14.6,
    cy: 14.6,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 14.8,
    cy: 14.3,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 15.1,
    cy: 14.1,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 15.3,
    cy: 14,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 15.7,
    cy: 13.9,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 16,
    cy: 13.8,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 16.3,
    cy: 13.8,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 16.6,
    cy: 13.8,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 17,
    cy: 13.8,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 17.2,
    cy: 13.6,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 17.5,
    cy: 13.5,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 17.8,
    cy: 13.4,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 18.1,
    cy: 13.3,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 18.4,
    cy: 13.3,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 18.8,
    cy: 13.4,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 20.1,
    cy: 13.4,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 20.4,
    cy: 13.3,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 20.8,
    cy: 13.3,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 21.1,
    cy: 13.4,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 21.4,
    cy: 13.5,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 21.7,
    cy: 13.6,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 21.9,
    cy: 13.8,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 22.3,
    cy: 13.8,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 22.6,
    cy: 13.8,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 22.9,
    cy: 13.8,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 23.2,
    cy: 13.9,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 23.5,
    cy: 14,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 23.8,
    cy: 14.1,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 24.1,
    cy: 14.3,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 24.3,
    cy: 14.6,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 24.5,
    cy: 14.8,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 24.5,
    cy: 15.2,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 24.5,
    cy: 15.5,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 24.4,
    cy: 15.8,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "es_st0",
    cx: 24.3,
    cy: 16,
    rx: 0.1,
    ry: 0.1
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSpain, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Spain.812bfe47.svg";
export { ForwardRef as ReactComponent };